module.exports = __webpack_public_path__ + "static/CSF4-bbb8c518fa6d5cdf4bca0a4803bbcf67.png";